import Utils from '../Utils/Utils';
import WS from './WS';
import PeerConnection from './PeerConnection';
import Sdp from './Sdp';

export default class Watch {
    
    constructor(el) {
        this.started = false;
        console.log(el)
        this.player = el;
        //this.start();
    }
    
    start() {
        this.started = true;
        this.wsConnection = new WS(this, 'wss://wowza.synople.tv/webrtc-session.json');
    }
    
    stop() {
        this.started = false;
        if(this.peer) {
            this.peer.close();
        }
        if(this.wsConnection) {
            this.wsConnection.close();
            this.wsConnection = null;
        }
    }
    
    onOpen(e) {
        this.peer = new PeerConnection(this);
        this.send('getOffer');
    }
    
    async onMessage(e) {
        
        let msg = JSON.parse(e.data);
		let status = Number(msg.status);
		let command = msg.command;
		
		console.log('onMessage', status);
		//console.log(msg);
		
		if (status != 200)
		{
			if(status == 504) {
			    await Utils.sleep(5000);
			    if(!this.videoconfStart)
			        this.send('getOffer');
			}
			else {
			    this.stop();
			}
		}
		else
		{
			var streamInfoResponse = msg.streamInfo;
			if (streamInfoResponse !== undefined)
				this.sessionId = streamInfoResponse.sessionId;
				
			let sdpData = msg.sdp;
			if (sdpData !== undefined)
			{
			    console.log(sdpData)
			    await this.peer.connection().setRemoteDescription(new window.RTCSessionDescription(sdpData)).catch((e) => { 
			        console.error('error webrtc', e)
			        return;
			    });
			    if(this.peer) {
				    let description = await this.peer.connection().createAnswer().catch((e) => { console.error(e) });
				
				    console.log(description)
				
				    /*const sdpObject = new Sdp(description.sdp);
		            if(!sdpObject.haveCodec('h264')) {
                        console.error('error webrtc video codec')
                        return;
                    }
                    
                    if(!sdpObject.hasVideo()) {
                        console.log('no video or audio yet')
                        await Utils.sleep(2000);
                        this.send('getOffer');
                    }
                    else {*/
	    			    this.peer.connection().setLocalDescription(description);
				        this.send('sendResponse', {
        			        sdp: description
	        		    });
                    //}
			    }
			    
			}

			var iceCandidates = msg.iceCandidates;
			if (iceCandidates !== undefined)
			{
				for(let index in iceCandidates)
				{
					this.peer.connection().addIceCandidate(new window.RTCIceCandidate(iceCandidates[index]));
				}
			}
		}
		
    }
    
    send(command, p) {
        let params = p || {};
        let sessionId = this.sessionId || '[empty]';
       
        let obj = {
            direction: 'play',
            command: command,
            streamInfo: {
                applicationName: window.sdk.live.streamInfo.source,
                streamName: window.sdk.live.streamInfo.program.stream_name,
                sessionId: sessionId
            },
            userData: {
            }
        };
        obj = Object.assign(params, obj);
        if(this.wsConnection)
            this.wsConnection.send(JSON.stringify(obj));
    }
    
    onIceCandidate(e) {
        
    }

    onAddStream(e) {
        console.info('onAddStream');
        this.player.srcObject = e.stream;
        this.player.play();
    }

    onRemoveStream(e) {

    }
    
    onSignalingStateChange(e) {
        
    }
    
    
}


// WEBPACK FOOTER //
// ./src/WebRTC/Watch.js